var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceSendGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9976_4598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.127 25.03V7.25003M12.127 7.25003C10.714 7.25003 9.574 4.31303 9.574 3.14903C9.574 1.98403 10.714 1.03003 12.127 1.03003C13.539 1.03003 14.679 1.97203 14.679 3.14903C14.679 4.32603 13.539 7.24903 12.126 7.24903L12.127 7.25003ZM5.659 3.50803C5.659 5.57803 8.546 7.25003 12.114 7.25003C15.682 7.25003 18.569 5.57703 18.569 3.50803M2.91 12.404H21.334V20.049C21.334 22.799 19.104 25.03 16.353 25.03H7.889C5.139 25.03 2.909 22.8 2.909 20.05V12.404H2.91ZM5.472 7.25003H18.78C19.9658 7.25162 21.1026 7.72339 21.9411 8.56189C22.7796 9.4004 23.2514 10.5372 23.253 11.723V12.404H1V11.723C1.00159 10.5372 1.47336 9.4004 2.31186 8.56189C3.15037 7.72339 4.28617 7.25162 5.472 7.25003Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9976_4598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "white",
    transform: "translate(0 0.0300293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceSendGift);
export default __webpack_public_path__ + "static/media/serviceSendGift.2886bbc852647ddbfb57b24ca6a8123a.svg";
export { ForwardRef as ReactComponent };